<template>
  <!-- :class="show ? 'show' : 'hide'" -->
  <div class="festivals" v-html="contentText"></div>
</template>

<script>
import { getValidMessage } from "@/api/activity";

export default {
  name: "",
  components: {},
  props: {
    areaType: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      contentText: "",
      show: true,
    };
  },
  computed: {},
  created() {
    console.log(this.areaType);
    if (this.areaType) {
      this.getValidMessage();
    } else {
      // this.contentText = `注意：（1）618大促期间短信发送时间：5月21日、5月22日、5月30日-6月1日、6月17日-6月18日 9:00-24:00 ；5月13日-5月20日、5月23日-5月29日、6月2日—6月16日 9:00-21:00 ；6月19日起恢复正常，即 09:00-20:00（*包含普通短信、富信、卡片短信）
      //    （2）5月13日-6月18日调整为大促期频控：同一店铺 2 天内给同一手机号发送商家营销短信的条数不超过 1条;每个手机号每 1天只能收到 5 条商家营销短信,每 2天只能收到 10 条商家营销短信；（*商家营销短信包括普通短信、富信、卡片短信）`;
    }
  },
  mounted() {
    let now = new Date(Date.now()).getTime();
    let end = new Date("2023-11-12 00:00:00").getTime();
    console.log("now: " + now + " end: " + end);
    if (now > end) {
      this.show = false;
    }
  },
  methods: {
    getValidMessage() {
      getValidMessage({
        areaType: this.areaType,
      }).then((res) => {
        if (res.code === 1) {
          console.log("换行符", res.data.content.indexOf("\n"));
          if (res.data.content) {
            let htmlStr = "";
            res.data.content.split("\n").forEach((item) => {
              htmlStr += `<div style="color:${
                res.data.color || "red"
              };white-space: pre-wrap;">${item}</div>`;
            });
            this.contentText = htmlStr;
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.hide {
  display: none;
}
.festivals {
  width: 100%;
  line-height: 25px;
  color: red;
  margin-left: 50px;
  margin-top: 30px;
  margin-bottom: 5px;
}
</style>
